window.FunCommunity = new function()
{
    this.init = function() {
        jQuery('#create-topic-modal, #edit-topic-modal, #create-subtopic-modal, #edit-subtopic-modal').on('shown.bs.modal', function (e) {
            ImagePreview.buildHtml();
        });

        jQuery('.see-more').click(function(event) {
            jQuery(this).closest('.post-body-overflow').addClass('expanded');
        });
        
        if(jQuery('body .post-card .post-body').hasClass('post-body-overflow')) {
            jQuery(this).find('.see-more').removeClass('hide');
        }

        //Close Sidebar Accordions at tablet
        if(window.innerWidth <= 1024) {
            if(jQuery('body').hasClass('post_grid_view')) {
                jQuery('.right-sidebar .accordion-title').removeClass('open');
                jQuery('.right-sidebar .accordion-body').hide();
            }
        }

        jQuery(window).resize( function() {
            if(window.innerWidth <= 1024) {
                if(jQuery('body').hasClass('post_grid_view')) {
                    jQuery('.right-sidebar .accordion-title').removeClass('open');
                    jQuery('.right-sidebar .accordion-body').hide();
                }
            }
        });
    };
}

jQuery(document).ready(function($) {
    FunCommunity.init();
});
